import React from "react";
// import BgOverlay from "../assets/contact-bg-overlay.webp";
import WhiteLogo from "../assets/contact-logo.webp";
import { FiPhone } from "react-icons/fi";
import { VscMail } from "react-icons/vsc";
import { GrLinkedinOption } from "react-icons/gr";
import { RiInstagramFill } from "react-icons/ri";
import { Link } from "react-router-dom";
import ContactForm from "./ContactForm";
import languageStorage from "../lang/findLanguage";

export default function Contact({ language }) {
  return (
    <div className="contact">
      <div className="container">
        <div className="contact-content">
          <img src={WhiteLogo} className="logo" alt="" />
          <p className="contact-desc">{languageStorage() === "tr" ? language[0].sections[8].keys[0].k0001 : language[1].sections[8].keys[0].k0001}</p>
          <div className="contact-item d-flex align-items-center">
            <FiPhone size="20" color="white" />
            <a href="tel:+9005359429679" target="_blank" rel="noreferrer">
              +90 535 942 96 79
            </a>
          </div>
          <div className="contact-item d-flex align-items-center">
            <VscMail size="20" color="white" />
            <a href="mailto:members@bandwitt.com" target="_blank" rel="noreferrer">
              members@bandwitt.com
            </a>
          </div>
          <div className="social-icons d-flex align-items-center">
            <Link to="#" onClick={() => window.open("https://www.linkedin.com/company/bandwitt-technologies/", "_blank")}>
              <GrLinkedinOption size="20" color="white" />
            </Link>
            <Link to="#" onClick={() => window.open("https://www.instagram.com/thebandwitt/", "_blank")}>
              <RiInstagramFill size="20" color="white" />
            </Link>
          </div>
          {/* <img className="bg-overlay" src={BgOverlay} alt="" /> */}
        </div>
        <ContactForm language={language} />
      </div>
    </div>
  );
}
